var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Hour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:#040F57;}\n\t.st7{fill:#BD2B48;}\n\t.st8{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 732,
    height: 460,
    xlinkHref: "52C25CE5.png",
    transform: "matrix(0.24 0 0 0.24 -5.88 26.76)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.2171,
    y1: 92.5054,
    x2: 5.3432,
    y2: 46.4402
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.8,74.6c-0.1,1.7-1.5,3.3-3.3,3.6c-1.7,0.2-3.1-1-3-2.7c0.1-1.7,1.5-3.3,3.3-3.6 C37.5,71.7,38.9,72.9,38.8,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.2777,
    y1: 92.4412,
    x2: 5.4037,
    y2: 46.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.2,41.6C16.6,44.6,2.3,61.4,2.3,79c0,17.6,14.3,29.5,31.9,26.5c0.7-0.1,1.5-0.3,2.2-0.5v-5.2 c-0.7,0.2-1.5,0.4-2.2,0.5c-14.7,2.5-26.7-7.4-26.7-22.2c0-14.7,12-28.8,26.7-31.3c14.7-2.5,26.7,7.4,26.7,22.2 c0,0,0,0.1,0,0.1l5.2-0.9c0,0,0-0.1,0-0.1C66.1,50.4,51.8,38.6,34.2,41.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.4211,
    y1: 88.0453,
    x2: 9.547,
    y2: 41.9799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.6,76.5c-0.8,0.1-1.4-0.4-1.4-1.2l0.1-16.8c0-0.8,0.7-1.6,1.5-1.7c0.8-0.1,1.4,0.4,1.4,1.2l-0.1,16.8 C37.1,75.6,36.5,76.4,35.6,76.5C35.7,76.5,35.6,76.5,35.6,76.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.1769,
    y1: 98.914,
    x2: -0.6972,
    y2: 52.8487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,80.1c-0.8,0.1-1.4-0.4-1.4-1.2c0-0.8,0.7-1.6,1.5-1.7l19-3c0.9-0.1,1.4,0.4,1.4,1.2 c0,0.8-0.7,1.6-1.5,1.7L15.5,80.1C15.6,80.1,15.6,80.1,15.5,80.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.4946,
    y1: 83.261,
    x2: 129.9511,
    y2: 83.261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#0B2273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#12348D"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "122.1,62.7 41.5,76.5 41.5,103.8 122.1,90.1 130,75  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1805,
    y1: 73.0633,
    x2: 98.1066,
    y2: 63.1387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06703911,
    style: {
      stopColor: "#BD2B48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4022,
    style: {
      stopColor: "#E79556"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "94.7,54.8 41.5,63.9 41.5,82 94.7,72.9 99.9,62.9  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.4,
    y: 95.5,
    transform: "matrix(0.9855 -0.1697 0.1697 0.9855 -14.7252 19.7799)",
    className: "st6",
    width: 79.8,
    height: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.4,
    y: 49.2,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -7.0007 16.7978)",
    className: "st7",
    width: 44.2,
    height: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 112.2,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -18.7438 4.5413)",
    className: "st7",
    width: 23.1,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 39.4,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -5.1082 19.6164)",
    className: "st6",
    width: 54.1,
    height: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.3,75.3l-5.4-2.4L51.5,71c0.8,0.5,1.6,0.7,2.4,0.5c0.3-0.1,0.6-0.2,0.7-0.4c0.1-0.2,0.2-0.5,0.1-0.7 c0-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.5-0.3-0.7-0.4c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3-0.1-0.5-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.4-0.9 c0-0.2,0-0.5,0-0.7l1.6-0.3c-0.1,0.2-0.1,0.4,0,0.5c0,0.2,0.2,0.4,0.4,0.5c0.2,0.2,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.3,0.9,0.4 c0.3,0.2,0.6,0.4,0.8,0.7c0.2,0.3,0.4,0.6,0.5,1.1c0.1,0.5,0,1-0.3,1.5c-0.3,0.4-0.7,0.7-1.3,0.9c0.5,0.1,1,0.3,1.4,0.5l0.8,0.4 L57.3,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.5,66.9c0.1,0.8-0.1,1.5-0.8,2.2c1,0.4,1.5,1.1,1.7,1.9c0.1,0.7,0,1.4-0.5,1.9c-0.4,0.5-1.1,0.8-1.9,1 c-0.8,0.1-1.5,0.1-2.1-0.2c-0.6-0.3-1-0.8-1.1-1.5c-0.1-0.8,0.1-1.6,0.9-2.3c-0.8-0.3-1.3-0.9-1.4-1.8c-0.1-0.7,0-1.3,0.5-1.8 c0.4-0.5,1.1-0.8,1.8-0.9c0.8-0.1,1.4,0,2,0.3C62,65.9,62.4,66.3,62.5,66.9z M58.9,67.8c0.1,0.5,0.4,0.8,0.9,1.1 c0.4-0.3,0.7-0.5,0.8-0.7c0.2-0.2,0.2-0.5,0.2-0.8c0-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.1-0.7-0.1c-0.3,0.1-0.6,0.2-0.7,0.4 C58.9,67.3,58.8,67.5,58.9,67.8z M60.7,72.4c0.3-0.1,0.6-0.2,0.7-0.4c0.2-0.2,0.2-0.5,0.2-0.8c-0.1-0.4-0.5-0.8-1.2-1.1 c-0.4,0.3-0.7,0.6-0.8,0.8c-0.2,0.2-0.2,0.5-0.2,0.8c0.1,0.3,0.2,0.5,0.4,0.6C60.1,72.4,60.3,72.5,60.7,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.9,64.4l-1,0.2l1.2,6.9l-1.7,0.3l-4.6-1l0,0l-0.3-1.5c0.5-0.4,1-0.9,1.4-1.2c-1.3,0-2-0.4-2.1-1.2 c-0.1-0.5,0.1-0.9,0.5-1.3l-1.3,0.2l-0.2-1.4l8-1.4L73.9,64.4z M70.8,68.3l-1.4,1.2l2.6,0.6l-0.9-5.2l-1.6,0.3 c-0.4,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.2,0.5-0.2,0.8c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.8-0.2 L70.8,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.4,64.9c1-0.2,1.7,0.1,2.4,0.7l-0.4-2l-5,0.9l-0.2-1.4l8.9-1.5c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1 c0-0.3-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.5,0.1-1.1,0.3c-0.5,0.2-0.9,0.3-1.2,0.3c-0.6,0.1-1,0.1-1.3,0 l-0.2-1.3c0.3,0.1,0.7,0.1,1.2,0c0.3,0,0.7-0.2,1.2-0.4c0.6-0.2,1-0.3,1.4-0.4c0.7-0.1,1.2,0,1.6,0.3c0.4,0.3,0.7,0.7,0.8,1.3 c0,0.2,0.1,0.4,0.1,0.6l1-0.2l0.2,1.4l-4.7,0.8l0.8,4.9c0,0.2,0.1,0.4,0.3,0.4c0.2,0.1,0.3,0.1,0.5,0.1c0.5-0.1,0.8-0.3,1.1-0.8 c0.2-0.4,0.3-0.9,0.2-1.4c-0.1-0.7-0.5-0.9-1.2-0.8c-0.2,0-0.4,0.1-0.5,0.1l-0.3-1.5c0.2-0.1,0.5-0.2,0.8-0.2 c0.8-0.1,1.5,0,2,0.4c0.5,0.4,0.8,1,1,1.7c0.2,0.9,0,1.7-0.5,2.5C83.8,69.5,83,70,82,70.2c-0.7,0.1-1.3,0-1.8-0.3 c-0.5-0.3-0.9-0.8-1-1.4l0-0.1c-0.1-0.6-0.4-1.1-0.7-1.6c-0.4-0.4-0.9-0.6-1.5-0.5c-0.3,0.1-0.5,0.2-0.6,0.4s-0.1,0.5-0.1,0.8 c0,0.2,0.1,0.5,0.2,0.7l-1.7,0.3c-0.1-0.3-0.2-0.6-0.3-0.8c-0.1-0.7,0-1.2,0.3-1.8C75.2,65.3,75.7,65,76.4,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.1,61.9l-1,0.2l1.2,6.9l-1.7,0.3l-1.1-6.1c-0.1-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.1-0.6-0.1l-0.4,0.1 l-0.2-1.4l0.6-0.1c0.3,0,0.5,0.1,0.7,0.3c-0.2-0.4-0.3-0.8-0.3-1.2l0-0.2l1.7-0.3l0.2,1l1-0.2L88.1,61.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.5,91.6l-1.7,0.3l-0.3-2.1c-0.1-0.8-0.5-1.2-1-1.1c-0.2,0-0.3,0.1-0.4,0.3c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.6,0.6c-0.3,0.2-0.6,0.3-1,0.4c-0.3,0.1-0.7,0.1-1,0l-0.2-1.4c0.2,0,0.5,0,0.7,0 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.5c-0.2-0.5-0.5-0.9-0.9-1.1 c-0.4-0.2-0.9-0.3-1.4-0.2L52,85.7l-0.7,0.1l-0.2-1.4l8.1-1.3l0.2,1.4l-1.1,0.2L59.5,91.6z M55.8,87.3c0.5-0.1,0.9,0,1.2,0.3 l-0.4-2.6l-3,0.5C54.6,85.7,55.4,86.3,55.8,87.3L55.8,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.8,83.9l-1.1,0.2l1.1,6.9l-1.7,0.3l-1-6.1c-0.1-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.1-0.6-0.1l-0.4,0.1 l-0.2-1.4l0.6-0.1c0.3,0,0.5,0.1,0.7,0.3c-0.2-0.4-0.3-0.8-0.3-1.2l0-0.2l1.7-0.3l0.2,1l1.1-0.2L62.8,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.3,90.4c-0.1,0-0.3,0.1-0.5,0.1c-0.5,0.1-0.9,0-1.2-0.1c-0.4-0.1-0.7-0.4-0.9-0.7 c-0.3-0.3-0.5-0.7-0.6-1.1c-0.2-0.4-0.3-0.8-0.4-1.3c-0.3-1.7-0.2-2.9,0.2-3.6L62.3,84L62,82.6l4.3-0.7l0.2,1.4l-0.4,0.1 c-0.3,0.1-0.5,0.2-0.7,0.4c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.4,0,0.7,0,1.1c0,0.4,0.1,0.8,0.2,1.3c0.2,1.4,0.7,2,1.5,1.8 c0.1,0,0.2,0,0.3-0.1L67.3,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.7,86.8l0.9-0.7c-0.4-0.5-0.9-0.8-1.4-0.8l-0.1-0.7c-0.1-0.7,0-1.4,0.4-2.1c0.4-0.7,1-1.1,1.9-1.2 c0.9-0.1,1.6,0.1,2,0.6l-0.3-1.8l1.7-0.3l0.2,1l1.1-0.2l0.2,1.4l-1.1,0.2l1.1,6.9l-1.7,0.3L72,85.3l-4,3.3L67.7,86.8z  M68.8,84.3c0.4,0.1,0.8,0.4,1.1,0.8l1.8-1.4c-0.3-0.8-0.9-1.1-1.7-0.9c-0.4,0.1-0.7,0.3-1,0.6C68.8,83.6,68.7,83.9,68.8,84.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M77.7,81.5l-1.1,0.2l1.1,6.9L76,88.8l-1-6.1c-0.1-0.3-0.1-0.5-0.2-0.6C74.7,82,74.5,82,74.2,82l-0.4,0.1 l-0.2-1.4l0.6-0.1c0.3,0,0.5,0.1,0.7,0.3c-0.2-0.4-0.3-0.8-0.3-1.2l0-0.2l1.7-0.3l0.2,1l1.1-0.2L77.7,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.6,84.1c0.1,0.9,0,1.7-0.5,2.5s-1.3,1.3-2.2,1.4c-0.7,0.1-1.3,0-1.8-0.3c-0.5-0.3-0.9-0.8-1-1.4 l-0.8-4.9l-1.1,0.2L77,80.2l4.9-0.8c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0-0.3-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.2,0-0.5,0.1-1.1,0.3c-0.5,0.2-0.9,0.3-1.2,0.3c-0.6,0.1-1,0.1-1.3-0.1l-0.2-1.3c0.3,0.1,0.7,0.1,1.2,0 c0.3,0,0.7-0.2,1.2-0.4c0.6-0.2,1-0.3,1.4-0.4c0.7-0.1,1.2,0,1.6,0.3c0.4,0.3,0.7,0.7,0.8,1.4c0,0.2,0,0.4,0,0.6l1-0.2l0.2,1.4 L80,81.1l0.8,4.9c0,0.2,0.1,0.4,0.3,0.4c0.2,0.1,0.3,0.1,0.5,0.1c0.5-0.1,0.8-0.3,1.1-0.8c0.2-0.4,0.3-0.9,0.2-1.4 c-0.1-0.7-0.5-0.9-1.2-0.8c-0.2,0-0.4,0.1-0.5,0.1l-0.2-1.5c0.2-0.1,0.5-0.2,0.8-0.2c0.8-0.1,1.5,0,2,0.4 C84.2,82.7,84.5,83.3,84.6,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.9,78.1l1.8-2.4l1.7-0.3l0,0l-1.8,2.4L78.9,78.1L78.9,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91.1,79.3L90,79.4l1.1,6.9l-1.7,0.3l-1.1-6.9l-1.1,0.2L87,78.5l1.1-0.2L88,77.8c-0.1-0.9,0-1.6,0.5-2.1 c0.5-0.5,1.2-0.9,2.2-1c0.6-0.1,1.2-0.1,1.9-0.1c0.7,0,1.2,0.1,1.5,0.2l0.2,1.3C93.9,76,93.4,76,92.8,76c-0.6,0-1.2,0-1.7,0.1 c-1,0.2-1.5,0.7-1.4,1.5l0.1,0.5l1-0.2L91.1,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.8,85.1l-1.7,0.3l-0.3-2.1c-0.1-0.8-0.5-1.2-1-1.1c-0.2,0-0.3,0.1-0.4,0.3c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.6,0.6c-0.3,0.2-0.6,0.3-1,0.4c-0.3,0.1-0.7,0.1-1,0l-0.2-1.4c0.2,0,0.5,0,0.7,0 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.5c-0.2-0.5-0.5-0.9-0.9-1.1 c-0.4-0.2-0.9-0.3-1.4-0.2l-0.2-1.3l-0.7,0.1l-0.2-1.4l8.1-1.3l0.2,1.4l-1.1,0.2L98.8,85.1z M95.1,80.8c0.5-0.1,0.9,0,1.2,0.3 l-0.4-2.6l-3,0.5C93.9,79.2,94.7,79.8,95.1,80.8L95.1,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M103.2,84.4c-0.1,0-0.3,0.1-0.5,0.1c-0.5,0.1-0.9,0-1.2-0.1c-0.4-0.1-0.7-0.4-0.9-0.7 c-0.3-0.3-0.5-0.7-0.6-1.1c-0.2-0.4-0.3-0.8-0.4-1.3c-0.3-1.7-0.2-2.9,0.2-3.6l-1.5,0.3L98,76.7l4.3-0.7l0.2,1.4l-0.4,0.1 c-0.3,0.1-0.5,0.2-0.7,0.4c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.4,0,0.7,0,1.1c0,0.4,0.1,0.8,0.2,1.3c0.2,1.4,0.7,2,1.5,1.8 c0.1,0,0.2,0,0.3-0.1L103.2,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.7,82.1c-0.1-0.6,0-1.2,0.3-1.7c0.3-0.5,0.7-0.9,1.3-1.3c-0.2-0.1-0.4-0.3-0.6-0.5 c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.6,0.4-1,0.4c-0.4,0.1-0.9,0-1.3-0.1l-0.2-1.4c0.5,0.1,0.9,0.1,1.2,0.1 c0.4-0.1,0.6-0.2,0.7-0.4s0.1-0.5,0.1-0.9l-2.7,0.4l-0.2-1.4l5.9-1c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0-0.3-0.1-0.4-0.2-0.5 s-0.3-0.1-0.5-0.1c-0.2,0-0.5,0.1-1.1,0.3c-0.5,0.2-0.9,0.3-1.2,0.3c-0.6,0.1-1,0.1-1.3-0.1l-0.2-1.3c0.3,0.1,0.7,0.1,1.2,0 c0.3,0,0.7-0.2,1.2-0.4c0.6-0.2,1-0.3,1.4-0.4c0.7-0.1,1.2,0,1.6,0.3c0.4,0.3,0.7,0.7,0.8,1.4c0,0.2,0,0.4,0,0.6l1-0.2l0.2,1.4 l-1,0.2c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.8-0.1,1.4-0.7,1.8c-0.2,0.1-0.5,0.4-0.9,0.6c-0.4,0.3-0.7,0.5-1,0.7 c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.3-0.2,0.6-0.2,0.9c0.1,0.7,0.6,0.9,1.6,0.8c0.8-0.1,1.2-0.4,1.1-0.7 c-0.1-0.3-0.4-0.4-0.9-0.3c-0.1,0-0.3,0.1-0.5,0.1l-0.2-1.3c0.2-0.1,0.4-0.1,0.6-0.1c0.7-0.1,1.2,0,1.7,0.2 c0.5,0.3,0.7,0.7,0.8,1.2c0.1,0.6-0.1,1.1-0.6,1.5c-0.5,0.4-1.1,0.7-1.9,0.9c-0.9,0.2-1.7,0.1-2.4-0.3 C105.2,83.5,104.8,82.9,104.7,82.1z M107.5,77.9c0.4-0.1,0.6-0.4,0.5-0.9c0-0.2-0.1-0.4-0.1-0.6l-1.5,0.2 C106.5,77.6,106.9,78,107.5,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M118.7,74.7l-1.4,0.2l1.1,6.9l-1.7,0.3l-0.2-1.1c-0.1-0.6-0.3-1.1-0.7-1.4c-0.4-0.3-0.8-0.4-1.4-0.3 c-0.3,0.1-0.6,0.2-0.8,0.3c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.3,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.1,0.7,0.1c0.1,0,0.3-0.1,0.5-0.1 l0.2,1.4c-0.2,0.1-0.5,0.2-0.8,0.2c-0.7,0.1-1.3,0-1.8-0.3c-0.5-0.3-0.8-0.8-0.9-1.5c-0.1-0.5,0-1,0.2-1.4c0.2-0.4,0.6-0.7,1-1 c-0.2-0.4-0.4-0.7-0.7-0.8c-0.3-0.1-0.7-0.2-1.2-0.1l-0.2-1.3l-0.8,0.1l-0.2-1.4l8.7-1.4L118.7,74.7z M116,78.6l-0.6-3.3 l-3.2,0.5c0.5,0.1,1,0.4,1.4,0.8c0.4,0.4,0.6,0.8,0.8,1.4C115.1,77.9,115.7,78.1,116,78.6z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Hour);
export default __webpack_public_path__ + "static/media/24Hour.39ab995a260bcfb40163b1604ff65966.svg";
export { ForwardRef as ReactComponent };